import React, { useContext } from "react"

import Layout from "../components/Layout"
import SEO from "../components/SEO"
import CourseList from "../components/courses/CourseList"
import OfficeHours from "../components/OfficeHours"
import Course from "../components/courses/Course"
import { DataContext } from "../contexts/DataContext"

const IndexPage = () => {
  const { isLoaded, semesters } = useContext(DataContext);

  return (
    <Layout>
      <SEO title="Teaching" />
      <h1>Teaching</h1>

      <OfficeHours />

      {isLoaded && semesters.map((semester, i) =>
        <CourseList key={i} title={`${semester.name} Courses`}>
          {semester.courses.map((course, c) =>
            <Course key={c} {...course} />
          )}
        </CourseList>
      )}
    </Layout>
  )
}

export default IndexPage
